(function() {
    var wdel = document.createElement('div');
    wdel.className = 'wdel';

    var cornerHtml = `
        <div class="wdel-title salesbeat-corner-widget">Доставка в
            <label for="wdel-modal-city">Москву</label>
            — курьером 2&nbsp;дня, 320&nbsp;руб, в
            <label for="wdel-modal-map">пункты самовывоза</label>
            3&nbsp;дня 210&nbsp;руб.</div>`

    wdel.innerHTML = `
        <div class="wdel-modal wdel-modal-city">
            <a href="javascript:void(0);" class="wdel-fader"></a>
            <div class="wdel-modal-inner">
                <div class="wdel-search">
                    <iframe src="${process.env.DJANGO_HOST}/widget/cities_choice/"
                            frameborder="0" name="salesbeatCityChoice">
                    </iframe>
                </div>
                <a href="javascript:void(0);" class="wdel-close"></a>
            </div>
        </div>
        <div class="wdel-modal wdel-modal-map">
            <a href="javascript:void(0);" class="wdel-fader"></a>
            <div class="wdel-modal-inner">
                <div id='sb-pvz-map' class="wdel-map"></div> 
                <a href="javascript:void(0);" class="wdel-close"></a>
            </div>
        </div>`;

    var _showHide = (selector, opened) => {
        const $el = wdel.querySelector(selector)
        $el.classList[opened ? 'add' : 'remove']('opened')

        if (selector == '.wdel-modal-city' && !opened) {
            SB.onHidePvzs()
        }
        if (selector == '.wdel-modal-city' && opened){
            document.dispatchEvent(new Event('sbCitiesPopupOpened'));
        }
        // document.querySelector(selector).checked = checked
    }

    var modal = {
        cities: {
            hide: () => _showHide('.wdel-modal-city', false),
            show: () => _showHide('.wdel-modal-city', true)
        },
        pvzMap: {
            hide: () => _showHide('.wdel-modal-map', false),
            show: () => _showHide('.wdel-modal-map', true),

            isOpened: _ => !!wdel.querySelector('.wdel-modal-map.opened')
        }
    }

    function render() {
        document.body.appendChild(wdel)
        
        const cityClosers = Array.from(wdel.querySelectorAll('.wdel-close, .wdel-fader'))
        const mapClosers = Array.from(wdel.querySelectorAll('.wdel-close, .wdel-fader'))
        for (let $closer of cityClosers) $closer.addEventListener('click', modal.cities.hide)
        for (let $closer of mapClosers) $closer.addEventListener('click', modal.pvzMap.hide)
    }

    if (document.body) {
        render()
    } else {
        document.addEventListener('DOMContentLoaded', render)
    }

    window.SB.modal = modal
})()
